import { useQuery, useQueries } from '@tanstack/react-query';
import useAPI from 'services/useAPI';
import createQueryRequest from 'services/createQueryRequest';
import { assetKeys } from 'components/Admin/Assets/queries';
import _ from 'lodash';


export const useAssets = () => {
  const api = useAPI();

  const query = useQuery({
    queryKey: assetKeys.assets(),
    queryFn: createQueryRequest(api.core.getAssets),
    initialData: []
  });

  return {
    assets: query.data,
    isLoading: query.isLoading,
    error: query.error,
    query
  };
};


export const useAsset = (assetId, optionalEnabled = true) => {
  const api = useAPI();

  const query = useQuery({
    enabled: !!assetId && optionalEnabled,
    queryKey: assetKeys.asset(assetId),
    queryFn: createQueryRequest(api.core.getAsset, assetId),
    staleTime: 3600000
  });

  return {
    asset: query.data,
    isLoading: query.isLoading,
    error: query.error,
    query
  };
};

export const useAssetQueries = (assetIds, optionalEnabled = true) => {
  const api = useAPI();

  const queries = useQueries({
    queries: assetIds.map((assetId) => {
      return {
        enabled: !!assetId && optionalEnabled,
        queryKey: assetKeys.asset(assetId),
        queryFn: createQueryRequest(api.core.getAsset, assetId),
        staleTime: 3600000
      };
    })
  });

  return {
    assets: _.compact(queries.map((query) => query.data)),
    isLoading: queries.some((query) => query.isLoading),
    error: queries.some((query) => query.error),
    queries
  };
};
